module.exports = __webpack_public_path__ + "static/media/bellezaHombre.cb4e166e.png";